import React, { useEffect, useState } from "react"
import SEO from "../../components/seo"
import PMPLayout from "../../components/index-components/pmp-layout"
import PMPHeader from "../../components/index-components/pmp-header"
import "../../styles/press-detail.scss"
import mockPressHeroImage from "../../assets/press/Caley-detail-desktop.png"
import mockPressHeroImageMobile from "../../assets/press/Caley-detail-mobile.png"

const MockPressReleasePage = () => {
  const pressRelease = {
    title: "<strong>inPowered AI Appoints Former Index Exchange VP Caley Lewis as SVP, Sales</strong> Following Rapid Growth on Index Platform",
    published_date: "2026-02-25T00:00:00",
    city_state: "San Francisco, CA",
    heroImageUrl: mockPressHeroImage,
    heroImageUrlMobile: mockPressHeroImageMobile,
    quote_blocks: [
        {
            text_1:"<p><strong> inPowered AI today announced the appointment of Caley Lewis, former VP, Sales (Americas) at Index Exchange, as SVP, Sales </strong></p>",
        },
        {
            text_1:
            "Lewis joins inPowered AI after witnessing firsthand the company’s rapid growth and performance impact through its AI-powered sell-side decisioning infrastructure deployed within Index Exchange’s platform. During her tenure at Index, she worked closely with agencies and brands adopting advanced decisioning technologies and saw inPowered AI’s models drive measurable performance improvements at scale.",
            quote:
            'From inside the exchange, I had a front-line view into how quickly inPowered AI’s technology was gaining traction and delivering results,” said Caley Lewis, SVP, Sales at inPowered AI. “This wasn’t incremental optimization - it was a structural shift in where intelligence lives in programmatic. Joining inPowered AI felt like a natural next step.”',
            text_2:
            "inPowered AI deploys proprietary AI models directly within supply-side infrastructure, evaluating every eligible impression in real time using contextual, environmental, and supply-level signals to predict outcomes before a bid is placed. By moving decisioning closer to the impression, the company enables agencies and brands to activate AI-curated supply designed to maximize performance, efficiency, and media quality.",
        },
        {
            quote:
            'We are incredibly excited to welcome Caley to inPowered AI,” said Peyman Nilforoush, Co-Founder & CEO of inPowered AI. “Caley is one of the most respected sales leaders in programmatic, with deep relationships and a front-row view into how the ecosystem is evolving. The fact that someone of her caliber - who witnessed our growth and performance impact firsthand - chose to join us is incredibly meaningful. It reinforces the momentum behind sell-side AI decisioning and signals how significant this shift has become for agencies and brands across the industry.”',
            text_2:
            "As agencies increasingly seek independent, AI-driven performance beyond walled gardens, inPowered AI continues to strengthen its position as the algorithmic layer powering outcome-based buying at the impression level.",
        },
    ],
    about_inpowered:
      "inPowered AI is the leading sell-side AI decisioning platform. The company’s AI models run directly on the exchange, enabling agencies and brands to deliver better outcomes through real-time, impression-level decisioning. The company is backed by strategic investors and industry operators and is at the forefront of enabling intelligence on the sell-side.",
  }

  const stripHtmlTags = htmlString => {
    if (!htmlString) return htmlString
    return htmlString.replace(/<[^>]*>/g, "")
  }

  const formatTitleWithHyphens = htmlString => {
    if (!htmlString) return htmlString
    return htmlString.replace(
      /(\w+-\w+)/g,
      '<span style="white-space: nowrap;">$1</span>'
    )
  }

  const formatDate = dateStr => {
    if (!dateStr) return "No date available"
    let date
    if (typeof dateStr === "string" && dateStr.includes("/")) {
      const parts = dateStr.split("/")
      if (parts.length === 3) {
        const [day, month, year] = parts
        date = new Date(`${month}/${day}/${year}`)
      } else {
        date = new Date(dateStr)
      }
    } else {
      date = new Date(dateStr)
    }
    if (isNaN(date.getTime())) return "Invalid date"
    return date.toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    })
  }

  const quoteBlocks = Array.isArray(pressRelease.quote_blocks)
    ? pressRelease.quote_blocks
    : []

  const hasQuoteBlocks = quoteBlocks.length > 0

  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768)
    }

    checkMobile()
    window.addEventListener("resize", checkMobile)

    return () => window.removeEventListener("resize", checkMobile)
  }, [])

  const heroImageUrl =
    isMobile && pressRelease.heroImageUrlMobile
      ? pressRelease.heroImageUrlMobile
      : pressRelease.heroImageUrl

  return (
    <PMPLayout showNavigation>
      <SEO
        title={stripHtmlTags(pressRelease.title) + " | Press Release"}
        description={pressRelease.summary}
        image={heroImageUrl}
        pageType="article"
      />

      <PMPHeader />

      <section className="hero has-background-dark hero-press-detail">
        <div className="hero-head container">
          <h1
            className="title is-1 is-size-3-mobile has-text-white mb-4 has-text-centered"
            dangerouslySetInnerHTML={{
              __html: formatTitleWithHyphens(pressRelease.title),
            }}
          />
        </div>

        <div className="press-detail-card-container">
          <div className="press-detail-card">
            <div className="press-detail-card-image">
              {heroImageUrl ? (
                <img
                  src={heroImageUrl}
                  alt={pressRelease.title}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    backgroundColor: "transparent",
                  }}
                />
              ) : null}
            </div>

            <div className="press-detail-card-content">
              <div className="press-detail-meta is-flex is-justify-content-flex-start has-text-weight-light">
                {pressRelease.city_state && (
                  <>
                    <span className="press-detail-location has-text-purple">
                      {pressRelease.city_state}
                    </span>
                    <span className="press-detail-separator has-text-purple">
                      -
                    </span>
                  </>
                )}
                <span className="press-detail-date has-text-purple">
                  {formatDate(pressRelease.published_date)}
                </span>
              </div>

              {pressRelease.summary && (
                <div className="press-detail-summary has-text-weight-light">
                  {pressRelease.summary}
                </div>
              )}

              {hasQuoteBlocks
                ? quoteBlocks.map((block, index) => (
                    <React.Fragment key={`quote-block-${index}`}>
                      {block.text_1 && (
                        <div
                          className="press-detail-text has-text-weight-light"
                          dangerouslySetInnerHTML={{ __html: block.text_1 }}
                          style={{ paddingTop: index !== 0 ? "1.5rem" : 0 }}
                        />
                      )}

                      {block.quote && (
                        <div className="press-detail-quote has-text-purple">
                          <p
                            className="quote"
                            aria-hidden="true"
                            style={{
                              fontSize: "120px",
                              lineHeight: 0.75,
                              color: "#0080FF",
                              height: 60,
                              marginLeft: -5,
                            }}
                          >
                            “
                          </p>
                          <p className="press-detail-quote-text has-text-weight-normal">
                            {block.quote}
                          </p>
                        </div>
                      )}

                      {block.text_2 && (
                        <div
                          className="press-detail-text has-text-weight-light"
                          dangerouslySetInnerHTML={{ __html: block.text_2 }}
                          style={{ paddingTop: index !== 0 ? "1.5rem" : 0 }}
                        />
                      )}
                    </React.Fragment>
                  ))
                : null}

              {!hasQuoteBlocks && pressRelease.text_1 && (
                <div
                  className="press-detail-text has-text-weight-light"
                  dangerouslySetInnerHTML={{ __html: pressRelease.text_1 }}
                />
              )}

              {!hasQuoteBlocks && pressRelease.quote && (
                <div 
                className="press-detail-quote has-text-purple"
                style={{ paddingTop: "1.5rem" }}
                >
                  <p
                    className="quote"
                    aria-hidden="true"
                    style={{
                      fontSize: "120px",
                      lineHeight: 0.75,
                      color: "#0080FF",
                      height: 60,
                      marginLeft: -5,
                    }}
                  >
                    “
                  </p>
                  <p className="press-detail-quote-text has-text-weight-normal">
                    {pressRelease.quote}
                  </p>
                </div>
              )}

              {!hasQuoteBlocks && pressRelease.text_2 && (
                <div
                  className="press-detail-text has-text-weight-light"
                  dangerouslySetInnerHTML={{ __html: pressRelease.text_2 }}
                  style={{ paddingTop: "1.5rem" }}
                />
              )}

              {pressRelease.about_inpowered && (
                <div className="press-detail-about has-text-purple">
                  <h3 className="press-detail-about-title has-text-weight-semibold has-text-purple">
                    About inPowered AI
                  </h3>
                  <div
                    className="press-detail-text has-text-weight-light"
                    dangerouslySetInnerHTML={{
                      __html: pressRelease.about_inpowered,
                    }}
                  />
                </div>
              )}
            </div>
          </div>
          <div className="press-hero-divider"></div>

          <span className="press-releases-grid-contact has-text-centered has-text-weight-light has-text-purple">
            For press inquiries please contact us at{" "}
            <a href="mailto:press@inpowered.ai">press@inpowered.ai</a>
          </span>
        </div>
      </section>
    </PMPLayout>
  )
}

export default MockPressReleasePage
